<div class="messagerie-container">
  <div class="conversation-list">
    @if (conversations$ | async; as conversations) { @if (conversations.length === 0) {
    <div class="empty-state">
      <div class="empty-icon">💬</div>
      <h3>Aucune conversation pour l'instant</h3>
      <p>Vos discussions apparaîtront ici une fois que vous aurez échangé avec quelqu'un !</p>
    </div>
    } @else { @for (conv of conversations; track conv.id) { @if (conv.participants) {
    <div
      class="conversation-card"
      [class.ended]="conv.isMatchCancelled"
      [class.expired]="
        conv.otherParticipantLeft &&
        !conv.isMatchCancelled &&
        !conv.isPermanent &&
        !conv.isHeartWindowExpired
      "
      [class.fully-expired]="
        conv.otherParticipantLeft &&
        !conv.isMatchCancelled &&
        !conv.isPermanent &&
        conv.isHeartWindowExpired
      "
      [class.permanent]="conv.isPermanent"
      [class.ephemeral]="!conv.isPermanent && !conv.isMatchCancelled && !conv.otherParticipantLeft"
      [class.unread]="conv.unreadCount > 0"
      (click)="openConversation(conv.id)"
      (keydown.enter)="openConversation(conv.id)"
      tabindex="0"
    >
      @if (conv.isMatchCancelled) {
      <div class="avatar-placeholder">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
          />
        </svg>
      </div>
      } @else {
      <div class="avatar-wrapper">
        <img
          [src]="
            otherParticipant(conv)?.imgUrl
              | versionedImageUrl : otherParticipant(conv)?.profileImageUpdatedAt
          "
          alt="avatar"
          loading="lazy"
        />
        @if (!conv.isPermanent && !conv.otherParticipantLeft) {
        <span class="ephemeral-badge" aria-hidden="true">
          <img src="assets/icons/time-bomb.svg" alt="" />
        </span>
        }
      </div>
      }

      <div class="card-content">
        <div class="content-header">
          <span class="name">{{ otherParticipant(conv)?.userName }}</span>
          <span class="timestamp">{{ formatMessageTime(conv.lastMessage?.sentAt) }}</span>
        </div>
        <div class="content-body">
          @if (conv.isMatchCancelled) {
          <span class="last-message ended-message">Conversation terminée</span>
          } @else if (conv.otherParticipantLeft && !conv.isPermanent && conv.isHeartWindowExpired) {
          <span class="last-message ended-message">Conversation expirée</span>
          } @else if (conv.otherParticipantLeft && !conv.isPermanent) {
          <span class="last-message expired-message"
            >A quitté le saloon - Envoyez un coup de cœur !</span
          >
          } @else {
          <span class="last-message">{{ conv.lastMessage?.content || 'Aucun message' }}</span>
          } @if (conv.unreadCount > 0) {
          <div class="unread-badge">{{ conv.unreadCount > 9 ? '9+' : conv.unreadCount }}</div>
          }
        </div>
      </div>

      @if (conv.isMatchCancelled) {
      <div class="actions-menu">
        <button
          type="button"
          class="menu-trigger"
          (click)="toggleMenu($event, conv.id)"
          aria-label="Options"
        >
          <span class="dots">•••</span>
        </button>
        @if (openMenuId === conv.id) {
        <div class="menu-dropdown">
          <button
            type="button"
            class="menu-item delete"
            (click)="confirmDeleteConversation($event, conv.id)"
          >
            <span class="icon">🗑️</span>
            Supprimer la conversation
          </button>
        </div>
        }
      </div>
      }
    </div>
    } } } }
  </div>
</div>
